import { Select, SelectProps } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useMaterialUIController } from 'context';

type SelectProperties = SelectProps & {
    name: string;
};

export function Selects(props: SelectProperties) {
    const { register } = useFormContext();
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    return (
        <Controller
            name={props.name}
            render={({ field }) => {
                return (
                    <Select
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline>legend>span': {
                                opacity: '0.8 !important',
                            },
                            '& .MuiOutlinedInput-notchedOutline>legend': {
                                display: 'flex',
                                alignItems: 'center',
                            },
                            // Dark mode styles
                            backgroundColor: darkMode ? '#141c2b' : '#ffffff',
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: darkMode ? '#405568' : 'rgba(0, 0, 0, 0.23)',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: darkMode ? '#5a6c7d' : 'rgba(0, 0, 0, 0.87)',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: darkMode ? '#1976d2' : '#1976d2',
                            },
                            '& .MuiSelect-select': {
                                color: darkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.87)',
                            },
                            '& .MuiSelect-icon': {
                                color: darkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.54)',
                            },
                            '&.Mui-disabled': {
                                backgroundColor: darkMode ? '#26324a' : '#f5f5f5',
                                '& .MuiSelect-select': {
                                    color: darkMode ? '#7a8a9a' : 'rgba(0, 0, 0, 0.38)',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: darkMode ? '#405568' : 'rgba(0, 0, 0, 0.12)',
                                },
                            },
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    backgroundColor: darkMode ? '#1b2536' : '#ffffff',
                                    '& .MuiMenuItem-root': {
                                        color: darkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.87)',
                                        '&:hover': {
                                            backgroundColor: darkMode
                                                ? '#26324a'
                                                : 'rgba(0, 0, 0, 0.04)',
                                        },
                                        '&.Mui-selected': {
                                            backgroundColor: darkMode
                                                ? '#26324a'
                                                : 'rgba(25, 118, 210, 0.12)',
                                            '&:hover': {
                                                backgroundColor: darkMode
                                                    ? '#3a4451'
                                                    : 'rgba(25, 118, 210, 0.16)',
                                            },
                                        },
                                    },
                                },
                            },
                        }}
                        size="medium"
                        id={props.name}
                        {...register(props.name)}
                        {...props}
                        {...field}
                    />
                );
            }}
        />
    );
}
